import classNames from 'classnames';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './Componenents.scss';

const DropdownSelect = ({
  value,
  className,
  isInvalid = false,
  options = [],
  valueKey = 'id',
  isDisabled = false,
  isMulti = false,
  getOptionLabel,
  getOptionValue,
  disabled = false,
  ...props
}) => {
  const selectedValues = isMulti
    ? value
    : options?.find(
        (option) => option[valueKey] === value || option[valueKey] === value?.[valueKey]
      );
  return (
    <Select
      className={classNames(
        'react-select',
        { 'is-invalid': isInvalid },
        { dropDownSelect_height: isMulti },
        className
      )}
      isDisabled={isDisabled || disabled}
      classNamePrefix="select"
      value={selectedValues || null}
      options={options}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      isMulti={isMulti}
      {...props}
    />
  );
};

DropdownSelect.propTypes = {
  value: PropTypes.any,
  className: PropTypes.string,
  isInvalid: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.object),
  valueKey: PropTypes.string,
  isDisabled: PropTypes.bool,
  isMulti: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  onChange: PropTypes.func,
};

DropdownSelect.defaultProps = {
  isInvalid: false,
  isDisabled: false,
  isMulti: false,
  options: [],
  valueKey: 'id',
};

export default DropdownSelect;
